<template>
  <b-overlay
      :show="showOverlay"
      rounded="sm"
  >
    <div>
      <!-- Table Container Card -->
      <b-card
          class="mb-2"
          no-body
      >
        <div class="m-2">
          <!-- Table Top -->
          <b-row>
            <!-- Search -->
            <b-col
                cols="12"
                md="6">
              <div class="d-flex align-items-center justify-content-end">
                <b-form-input
                    v-model="searchCommand"
                    class="d-inline-block mr-1"
                    placeholder="جستجو..."
                />
              </div>
            </b-col>
            <b-col
                class="d-flex align-items-center justify-content-end my-1 my-md-0 ml-auto"
                cols="12"
                md="3"
            >
              <label>نمایش</label>
              <v-select
                  v-model="perPage"
                  :clearable="false"
                  :options="perPageOptions"
                  class="per-page-selector d-inline-block mx-50"
              />
              <label>از {{ totalCounts }} نظر</label>
            </b-col>
          </b-row>
        </div>
      </b-card>

      <b-card
          v-if="comments.length > 0"
          class="mb-2 p-2"
          no-body
          v-for="(comment,idx) in comments"
          :key="comment.productCommentId"
      >
        <b-row>
          <b-col
              class="my-1"
              cols="12"
          >
            <b-row>
              <b-col
                  class="d-flex align-items-center justify-content-start"
                  cols="6"
              >
                <b-media vertical-align="center">
                  <template #aside>
                    <b-avatar
                        size="45"
                        :src="baseUrl+comment.userInfo.selfieFileData"
                        :variant="`success`"
                        :to="{ name: 'apps-users-edit', params: { id: comment.userInfo.userId } }"
                    />
                  </template>
                  <b-link
                      :to="{ name: 'apps-users-edit', params: { id: comment.userInfo.userId } }"
                      class="font-weight-bold d-block text-nowrap mb-1"
                  >
                    {{ comment.userInfo.name + ' ' + comment.userInfo.familyName }}
                  </b-link>
                  <span class="d-flex align-items-center justify-content-center">{{ comment.createDate.slice(11, 16) }} - {{
                      createJalaliDate(comment.createDate.slice(0, 10))
                    }} <feather-icon
                        icon="CalendarIcon" class="ml-50"/></span>
                </b-media>
              </b-col>
              <b-col
                  class="d-flex align-items-center justify-content-end"
                  cols="6"
              >
                <div class="d-flex align-items-center justify-content-center">
                  <span class="mr-1">نظر منتخب</span>
                  <b-form-checkbox
                      :checked="comment.isSelectedForMainPage"
                      name="check-button"
                      @change="switchState(comment)"
                      switch
                      inline
                  >
                  </b-form-checkbox>
                </div>
                <div class="d-flex align-items-center justify-content-center">
                  <span class="mr-1">وضعیت تایید</span>
                  <b-form-checkbox
                      :checked="comment.isVerify"
                      name="check-button"
                      @change="switchIsVerifyState(comment)"
                      switch
                      inline
                  >
                  </b-form-checkbox>
                </div>
                <b-button
                    variant="primary"
                    tag="a"
                    v-b-modal.modal-reply
                    @click="selectCommentToReply(comment)"
                >
                  <feather-icon icon="Edit2Icon" class="mr-50"/>
                  <span>پاسخ</span>
                </b-button>
                <b-button
                    variant="danger"
                    tag="a"
                    class="btn-wishlist ml-1"
                    v-b-modal.modal-delete
                    @click="showModal(comment.productCommentId)"
                >
                  <feather-icon
                      icon="TrashIcon"
                      class="mr-50"
                  />
                  <span>حذف</span>
                </b-button>
              </b-col>
            </b-row>
          </b-col>
          <b-col
              class=""
              cols="12"
          >
            <p>{{ comment.message }}</p>
          </b-col>
          <template v-if="comment.replies && comment.replies.length > 0">
            <b-col
                cols="12"
            >
              <hr class="">
            </b-col>
            <b-col
                v-for="(reply,index) in comment.replies" :key="reply.productCommentId"
                class="mx-auto"
                cols="8"
            >
              <b-row>
                <b-col
                    class="my-1"
                    cols="12"
                >
                  <b-row>
                    <b-col
                        class="d-flex align-items-center justify-content-start"
                        cols="6"
                    >
                      <b-media vertical-align="center">
                        <template #aside>
                          <b-avatar
                              size="45"
                              :src="baseUrl+reply.userInfo.selfieFileData"
                              :variant="`success`"
                              :to="{ name: 'apps-users-edit', params: { id: reply.userInfo.userId } }"
                          />
                        </template>
                        <b-link
                            :to="{ name: 'apps-users-edit', params: { id: reply.userInfo.userId } }"
                            class="font-weight-bold d-block text-nowrap mb-1"
                        >
                          {{ reply.userInfo.name + ' ' + reply.userInfo.familyName }}
                        </b-link>
                        <span
                            class="d-flex align-items-center justify-content-center">{{
                            reply.createDate.slice(11, 16)
                          }} - {{ createJalaliDate(reply.createDate.slice(0, 10)) }} <feather-icon
                              icon="CalendarIcon" class="ml-50"/></span>
                      </b-media>
                    </b-col>
                    <b-col
                        class="d-flex align-items-center justify-content-end"
                        cols="6"
                    >
                      <div class="d-flex align-items-center justify-content-center">
                        <span class="mr-1">وضعیت تایید</span>
                        <b-form-checkbox
                            :checked="reply.isVerify"
                            name="check-button"
                            @change="switchIsVerifyState(reply)"
                            switch
                            inline
                        >
                        </b-form-checkbox>
                      </div>
                      <b-button
                          variant="danger"
                          tag="a"
                          class="btn-wishlist ml-1"
                          v-b-modal.modal-delete
                          @click="showModal(reply.productCommentId)"
                      >
                        <feather-icon
                            icon="TrashIcon"
                            class="mr-50"
                        />
                        <span>حذف</span>
                      </b-button>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col
                    class=""
                    cols="12"
                >
                  <p>{{ reply.message }}</p>
                </b-col>
                <b-col
                    v-if="index+1 !== comment.replies.length"
                    cols="12"
                >
                  <hr class="">
                </b-col>
              </b-row>
            </b-col>
          </template>
        </b-row>
      </b-card>
      <div v-else class="w-100 text-center">
        <p>موردی یافت نشد!</p>
      </div>

      <div class="mx-2 m-2" v-if="comments.length > 0">
        <b-row>
          <!-- Pagination -->
          <b-col
              class="d-flex align-items-center justify-content-center"
              cols="12"
          >
            <b-pagination
                v-model="currentPage"
                :per-page="perPage"
                :total-rows="totalCounts"
                class=""
                first-number
                last-number
                next-class="next-item"
                prev-class="prev-item"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon"
                              size="18"
                              style="transform: rotate(180deg)"
                />
              </template>
              <template #next-text>
                <feather-icon
                    icon="ChevronRightIcon"
                    size="18"
                />
              </template>
            </b-pagination>
          </b-col>
        </b-row>
      </div>
    </div>
    <b-modal
        id="modal-delete"
        cancelTitle="انصراف"
        centered
        ok-title="حذف"
        @ok="deleteComment(deleteItem)"
    >
      <span>حذف شود؟</span>
    </b-modal>

    <b-modal
        id="modal-reply"
        centered
        ok-only
        ok-title="ثبت"
        title="ثبت پاسخ برای دیدگاه کاربر"
        @ok="createNewComment"
    >
      <b-form-group
          label="پاسخ شما :"
          label-for="name-input"
      >
        <b-form-textarea
            id="name-input"
            v-model="commentMessage"
            required
        ></b-form-textarea>
      </b-form-group>
    </b-modal>
  </b-overlay>
</template>

<script>
import {
  BAvatar, BButton,
  BCard,
  BCol,
  BFormCheckbox,
  BFormGroup,
  BFormInput,
  BLink, BMedia,
  BModal,
  BOverlay,
  BPagination,
  BRow,
  BTable,
  BFormTextarea
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import Helper from "@/libs/Helper";
import {
  ProductCommentCreateRequest,
  ProductCommentDeleteRequest,
  ProductCommentsGetByIdRequest,
  ProductCommentToggleIsVerifyRequest,
  ProductCommentToggleShowInMainPageRequest,
  GetProductCommentsByIdForAdmin
} from "@/libs/Api/Product";
import ToastificationContent from "@core/components/toastification/ToastificationContent";

export default {
  title: "لیست نظرات محصول - پنل ادمین ذهن آرایی",
  name: "ProductCommentsById",
  data() {
    return {
      comments: [],
      productId: this.$route.params.id,
      showOverlay: false,
      baseUrl: Helper.baseUrl,
      currentPage: 1,
      totalCounts: null,
      IsSelectedForMainPage: false,
      perPage: 10,
      type: '',
      deleteItem: null,
      perPageOptions: [10, 20, 30, 40, 50],
      commentMessage: '',
      selectedCommentId: null,
      selectedCommentProductId: null,
      searchCommand: null,
    }
  },
  computed: {
    computedPageRouteQuery() {
      if (this.$route.query && this.$route.query.productsListPageNumber) {
        return this.$route.query.productsListPageNumber;
      }
      return 1;
    },
  },
  async created() {
    await this.getComments();
  },
  methods: {
    setPageNumberQuery(pageNumber) {
      this.$router.replace({
        path: this.$route.path,
        query: {
          productsListPageNumber: pageNumber,
        },
      });
    },
    async getComments() {
      let _this = this;
      _this.showOverlay = true;

      let data = {
        pageNumber: _this.currentPage,
        count: _this.perPage,
        searchCommand: _this.searchCommand,
        productId: _this.productId
      }

      if (data.searchCommand === null || data.searchCommand === undefined || data.searchCommand === "") {
        delete data.searchCommand
      }

      let productCommentsGetByIdRequest = new GetProductCommentsByIdForAdmin(_this);
      productCommentsGetByIdRequest.setParams(data);
      await productCommentsGetByIdRequest.fetch(function (content) {
        _this.showOverlay = false;
        _this.comments = content.data.data;
        _this.totalCounts = content.data.total;
        if (_this.computedPageRouteQuery) {
          _this.currentPage = +_this.computedPageRouteQuery;
        } else {
          _this.currentPage = 1;
        }
      }, function (error) {
        _this.showOverlay = false;
      })
    },
    async switchState(item) {
      let _this = this;
      _this.showOverlay = true;

      let productCommentToggleShowInMainPageRequest = new ProductCommentToggleShowInMainPageRequest(_this);
      productCommentToggleShowInMainPageRequest.setParams({ProductCommentId: item.productCommentId})
      await productCommentToggleShowInMainPageRequest.fetch(() => {
        _this.showOverlay = false;
        _this.$toast({
          component: ToastificationContent,
          position: 'bottom-center',
          props: {
            title: `عملیات موفق`,
            icon: 'CheckIcon',
            variant: 'success',
          },
        })
        this.getComments()
      }, (error) => {
        _this.showOverlay = false;
      })
    },
    async switchIsVerifyState(item) {
      let _this = this;
      _this.showOverlay = true;

      let productCommentToggleIsVerifyRequest = new ProductCommentToggleIsVerifyRequest(_this);
      productCommentToggleIsVerifyRequest.setParams({ProductCommentId: item.productCommentId})
      await productCommentToggleIsVerifyRequest.fetch(() => {
        _this.showOverlay = false;
        _this.$toast({
          component: ToastificationContent,
          position: 'bottom-center',
          props: {
            title: `عملیات موفق`,
            icon: 'CheckIcon',
            variant: 'success',
          },
        })
        this.getComments()
      }, (error) => {
        _this.showOverlay = false;
      })
    },
    async createNewComment() {
      let _this = this;
      _this.showOverlay = true;

      let data = {
        productId: _this.selectedCommentProductId,
        message: _this.commentMessage,
        parentId: _this.selectedCommentId
      }

      let createBlogCommentRequest = new ProductCommentCreateRequest(_this);
      createBlogCommentRequest.setParams(data);
      await createBlogCommentRequest.fetch(function (content) {
        _this.showOverlay = false;
        _this.$toast({
          component: ToastificationContent,
          position: 'bottom-center',
          props: {
            title: `عملیات موفق`,
            icon: 'CheckIcon',
            variant: 'success',
            text: `پاسخ شما ثبت شد.`,
          },
        })
        _this.commentMessage = '';
        _this.selectedCommentId = null;
        _this.selectedCommentBlogId = null
        _this.getComments();
      }, function () {
        _this.showOverlay = false;
      });
    },
    async deleteComment(param) {
      let _this = this;
      _this.showOverlay = true;

      let productCommentDeleteRequest = new ProductCommentDeleteRequest(_this);
      productCommentDeleteRequest.setId(param);
      await productCommentDeleteRequest.fetch(function (content) {
        _this.showOverlay = false;
        _this.$toast({
          component: ToastificationContent,
          position: 'bottom-center',
          props: {
            title: `عملیات موفق`,
            icon: 'CheckIcon',
            variant: 'success',
            text: `حذف شد.`,
          },
        })
        _this.getComments()
      }, function (error) {
        _this.showOverlay = false;
      })
    },
    selectCommentToReply(comment) {
      this.selectedCommentId = comment.productCommentId;
      this.selectedCommentProductId = comment.productId;
    },
    createJalaliDate(param) {
      return new Date(param).toLocaleDateString("fa-IR",);
    },
    makePrettyPrice(param) {
      return Helper.prettyPrice(param, 0)
    },
    showModal(param) {
      let _this = this;
      _this.deleteItem = param
    },
  },
  watch: {
    perPage: function (nv, ov) {
      this.getComments();
    },
    currentPage: function (nv, ov) {
      this.getComments();
      this.setPageNumberQuery(nv);
    },
    searchCommand: function (nv, ov) {
      this.getComments();
    },
    type: function (nv, ov) {
      this.getComments();
    },
    IsSelectedForMainPage(nv, ov) {
      this.getComments();
    },
  },
  components: {
    BButton,
    BAvatar, BMedia,
    BFormCheckbox,
    BFormGroup,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BTable,
    BLink,
    BPagination,
    BOverlay,
    BModal,
    vSelect,
    BFormTextarea,
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
